import styled from 'styled-components';

export const StyledMetricsContainer = styled.div`
  margin-top: 16px;
`;
